import { motion } from "framer-motion";
import { ScrollText, Trees, Handshake, Award } from "lucide-react";

const pillars = [
  { icon: ScrollText, title: "Escrituras a tu nombre", desc: "Cada lote escriturado, libre de gravamen. Documentación transparente desde el día uno." },
  { icon: Trees,      title: "Tierra virgen certificada", desc: "Suelo nunca cultivado ni intervenido. Conservación ambiental priorizada." },
  { icon: Handshake,  title: "Reglas comunitarias", desc: "Sin vallas, sólo barreras orgánicas. Convivencia pactada para preservar el entorno." },
  { icon: Award,      title: "Plusvalía sostenida", desc: "Ubicación premium entre Xico y los Cañones de Pextlán, polos turísticos en crecimiento." },
];

export default function TrustSection({ content = {} }) {
  return (
    <section
      id="confianza"
      data-testid="trust-section"
      className="relative py-28 overflow-hidden bg-[#0B1A0F]"
    >
      <div className="orb w-[420px] h-[420px] bg-[#B8E07A]/25 top-1/4 -left-32" />
      <div className="orb w-[360px] h-[360px] bg-[#F1C36B]/25 bottom-0 right-0" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-5 relative"
            style={{ perspective: "1200px" }}
          >
            <motion.div
              whileHover={{ rotateY: 6, rotateX: -3 }}
              className="relative rounded-3xl overflow-hidden border border-[#F1C36B]/30 shadow-[0_40px_100px_-30px_rgba(0,0,0,0.7)]"
              style={{ transformStyle: "preserve-3d" }}
            >
              <img
                src="https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1200&q=85"
                alt="Bosque protegido"
                className="w-full h-[460px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1A0F]/85 via-[#0B1A0F]/30 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-[#F2EFE6]">
                <div className="text-[11px] uppercase tracking-[0.25em] text-[#F1C36B]">{content.trust_seal_overline || "Sello Pextlán"}</div>
                <div className="mt-1 font-serif text-2xl">
                  {content.trust_seal_title || "Garantía ecológica + jurídica"}
                </div>
                <div className="font-fairy text-2xl text-[#B8E07A] -mt-0.5">
                  {content.trust_seal_fairy || "cuidamos el bosque y tu inversión"}
                </div>
              </div>
            </motion.div>
            <div className="absolute -top-6 -right-6 w-32 h-32 rounded-full bg-[#F1C36B]/40 blur-3xl" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <span className="text-xs uppercase tracking-[0.3em] font-medium text-[#F1C36B]">
              {content.trust_overline || "¿Por qué Pextlán?"}
            </span>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F2EFE6] leading-[1.05]">
              {content.trust_title_1 || "Un patrimonio"}{" "}
              <span className="font-fairy gold-shimmer">{content.trust_title_fairy || "con alma de bosque"}</span>
            </h2>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              {pillars.map((p, i) => (
                <motion.div
                  key={p.title}
                  initial={{ opacity: 0, y: 25 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  whileHover={{ y: -4, rotateY: 4 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  data-testid={`trust-pillar-${i}`}
                  className="group relative rounded-2xl bg-[#15301E]/70 backdrop-blur border border-[#B8E07A]/15 p-5 hover:border-[#F1C36B]/50 transition-colors"
                  style={{ transformStyle: "preserve-3d" }}
                >
                  <div className="w-11 h-11 rounded-full bg-[#0B1A0F] text-[#B8E07A] flex items-center justify-center mb-3 group-hover:bg-[#F1C36B] group-hover:text-[#0B1A0F] transition-colors border border-[#B8E07A]/30">
                    <p.icon className="w-5 h-5" />
                  </div>
                  <h3 className="font-serif text-xl text-[#F2EFE6]">{p.title}</h3>
                  <p className="mt-1.5 text-sm text-[#F2EFE6]/70 leading-relaxed">
                    {p.desc}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
